export const routes = [
  {
    path: '/payments/dashboard',
    name: 'payments.dashboard',
    component: () => import('./dashboard/Index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Dashboard de Bilheteria',
      showNavbar: true,
      roles: ['Admin', 'Master']
    }
  },
  {
    path: '/payments/tickets',
    name: 'payments.tickets',
    component: () => import('./tickets/Index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Gerenciar Ingressos',
      showNavbar: true,
      roles: ['Admin', 'Master']
    }
  },
  {
    path: '/payments/cupons',
    name: 'payments.cupons',
    component: () => import('./cupons/Index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Cupons de Desconto',
      showNavbar: true,
      roles: ['Admin', 'Master']
    }
  },
  {
    path: '/payments/recipient',
    name: 'payments.recipient',
    component: () => import('./recipient/Index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Configuração de Recebedor',
      showNavbar: true,
      roles: ['Admin', 'Master']
    }
  },
  {
    path: '/payments/gateway',
    name: 'payments.gateway',
    component: () => import('./gateway/Index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Configuração do Gateway',
      showNavbar: true,
      roles: ['Admin', 'Master']
    }
  },
  {
    path: '/payments/transfers',
    name: 'payments.transfers',
    component: () => import('./transfers/Index.vue'),
    meta: {
      requiresAuth: true,
      title: 'Transferências',
      showNavbar: true,
      roles: ['Admin', 'Master']
    }
  }
]
